// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.

/**
 * Knobs build-time del bloque ContenidoConImagen que no son CSS.
 * Vienen de ThemeConfiguration via `npm run themeconfig` — refleja
 * cualquier cambio sólo tras regenerar.
 */
export type GeneratedContentImageConfig = {
  inversoMobileTextoArriba: boolean;
};

export const generatedContentImageConfig: GeneratedContentImageConfig = {
  "inversoMobileTextoArriba": false
};
